import { Card, List, ListItem, ListItemSecondaryAction } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import axios from 'axios';
import Hashids from 'hashids';
import React, { useEffect, useState } from 'react';
import { ChevronRight as ChevronRightIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from '@/components/common/breadcrumb.component';
import { Constants } from '@/constants';

const hashids = new Hashids('', 12);

const UsersView = () => {
  const navigate = useNavigate();
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // FIXME These are technically listed in Firebase so see if they can be pulled from there - may need to cross-reference with Boxpressd db
    axios
      .get(`${Constants.apiPath}/users`)
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoadingUsers(false));
  }, []);

  return (
    <div>
      <Breadcrumb title="Team" label="Team" parent="Settings" />

      <div className="container-fluid">
        <div
          style={{
            maxWidth: 800,
            width: '100%',
            margin: '30px auto',
          }}
        >
          {!loadingUsers && users.length === 0 && <span>Coming soon!</span>}
          {!loadingUsers && users.length > 0 && (
            <Card
              style={{
                maxWidth: 1200,
                width: '100%',
                margin: '30px auto',
              }}
            >
              <List>
                {users
                  .sort((a, b) => a.name.localeCompare(b.name))
                  .map((user) => (
                    <ListItem
                      key={user.user_id}
                      onClick={() =>
                        navigate(
                          `/settings/users/${hashids.encode(user.user_id)}`
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      <ListItemText
                        primary={user.name}
                        secondary={user.description}
                      />
                      <ListItemSecondaryAction>
                        <ChevronRightIcon
                          style={{
                            height: 18,
                            width: 18,
                            marginLeft: 10,
                            cursor: 'pointer',
                          }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
              </List>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default UsersView;
